// Responsive media for rail, cart, detail crops and ordinary product images.
// Interactive surfaces exclusively own their decoded frame and sizing.
const records=new Map();
const resize=new ResizeObserver(entries=>{for(const e of entries)update(e.target);});
const set=(n,k,v)=>{if(n.getAttribute(k)!==v)n.setAttribute(k,v);};
function update(img){
 // The 360 dialog is not an ordinary responsive photo. Its transformed width
 // must never be written back into sizes/srcset: this changes the decoded source
 // during zoom and can create fractional ResizeObserver feedback in WebKit.
 if(img.closest('[data-three-olives-stage],[data-three-olives-poster-only],.r290-view')){
  if(records.has(img)){resize.unobserve(img);records.delete(img);}return;
 }
 const src=img.getAttribute('src')||'';
 if(!/\/3os-(?:r11|290)-(tennis-500|triathlon-1l)-poster\.webp(?:\?|$)/.test(src))return;
 const width=Math.max(120,Math.ceil(img.getBoundingClientRect().width||240));
 const srcset=[120,240,480,720,1120].map(w=>(w===1120?src:src.replace('-poster.webp','-'+w+'.webp'))+' '+w+'w').join(', ');
 set(img,'srcset',srcset);set(img,'sizes',width+'px');
 img.closest('picture')?.querySelectorAll('source').forEach(s=>{set(s,'srcset',srcset);set(s,'sizes',width+'px');});
 if(!records.has(img)){records.set(img,true);resize.observe(img);}
}
function scan(){
 document.querySelectorAll('img[src*="/3os-r11-"],img[src*="/3os-290-"]').forEach(update);
 for(const img of records.keys())if(!img.isConnected){resize.unobserve(img);records.delete(img);}
}
let frame=0;
const observer=new MutationObserver(()=>{frame ||= requestAnimationFrame(()=>{frame=0;scan();});});
observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['src']});
scan();document.fonts.ready.then(scan);
